import WOW from './wow';

// WOW
const wow = new WOW();
wow.init();